import React from 'react';
import PropTypes from 'prop-types';

function ChallengeIcon({ id }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 91 91"
      version="1.1"
      viewBox="0 0 91 91"
      xmlSpace="preserve"
      role="img"
      aria-labelledby="challenge-icon-title"
    >
      <title id="challenge-icon-title">Challenge Icon</title>
      <g>
        <g transform="translate(6 4)">
          <g>
            <linearGradient
              id={`path-2_2_${id}`}
              x1="-428.467"
              x2="-428.467"
              y1="319.596"
              y2="317.776"
              gradientTransform="matrix(50 0 0 -50 21462.836 15975.786)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" className="startColor" />
              <stop offset="1" className="endColor" />
            </linearGradient>
            <circle
              cx="39.5"
              cy="41.5"
              r="45.5"
              fill={`url(#path-2_2_${id})`}
            />
          </g>
          <g transform="translate(10 9)">
            <g>
              <g>
                <g transform="translate(0 .167)">
                  <g fill="#A77129" transform="translate(4.235 25.838)">
                    <path d="M7.1 34.5c-1.3-.7-1.7-2.4-1-3.7l3.5-6.1 4.7 2.7-3.5 6.1c-.7 1.3-2.4 1.8-3.7 1z" />
                    <path d="M38.7 34.5c1.3-.7 1.7-2.4 1-3.7l-3.5-6.1-4.7 2.7 3.5 6.1c.7 1.3 2.3 1.8 3.7 1z" />
                  </g>
                  <circle cx="27.1" cy="30.7" r="24.8" fill="#A77129" />
                  <g fill="#2DBBA5" transform="translate(4.235 24.61)">
                    <path d="M7.1 33.5c-1.3-.7-1.7-2.4-1-3.7l3.5-6.1 4.7 2.7-3.5 6.1c-.7 1.3-2.4 1.8-3.7 1z" />
                    <path d="M38.7 33.5c1.3-.7 1.7-2.4 1-3.7l-3.5-6.1-4.7 2.7 3.5 6.1c.7 1.3 2.3 1.8 3.7 1z" />
                  </g>
                  <g fill="#00A58C" transform="translate(4.235 25.9)">
                    <path d="M38.7 30.8c-1.3.7-3 .3-3.7-1l-2.9-5-.6.3 3.5 6.1c.7 1.3 2.4 1.7 3.7 1 1.1-.6 1.6-1.9 1.3-3-.3.7-.7 1.3-1.3 1.6z" />
                    <path d="M10.8 29.8c-.7 1.3-2.4 1.7-3.7 1-.6-.4-1.1-1-1.3-1.7-.3 1.2.2 2.4 1.3 3 1.3.7 3 .3 3.7-1l3.5-6.1-.6-.3-2.9 5.1z" />
                  </g>
                  <circle cx="27.1" cy="28.4" r="24.8" fill="#595D6E" />
                  <circle cx="27.1" cy="28.4" r="19.7" fill="#FFF" />
                  <path
                    fill="#A77129"
                    d="M27.1 8c-11.1 0-20 9-20 20s9 20 20 20C16.2 48 7.4 39.2 7.4 28.3S16.3 8.8 27.1 8.8s19.7 8.8 19.7 19.7S38 48.1 27.1 48.1c11.1 0 20-9 20-20S38.2 8 27.1 8z"
                  />
                  <circle cx="27.1" cy="28.4" r="14.5" fill="#1CAEE4" />
                  <circle cx="27.1" cy="28.4" r="9" fill="#FFF" />
                  <path
                    fill="#177BC0"
                    d="M27.1 19.4c4.9 0 8.9 3.9 9 8.8v-.3c0-5-4.1-9-9-9s-9 4.1-9 9v.3c.1-4.9 4.1-8.8 9-8.8z"
                  />
                  <circle cx="27.1" cy="28.4" r="5" fill="#E7AD27" />
                  <path
                    fill="#FFC733"
                    d="M27.1 23.5c-2.6 0-4.8 2-5 4.6.2 2.6 2.3 4.6 5 4.6s4.8-2 5-4.6c-.2-2.6-2.4-4.6-5-4.6z"
                  />
                  <g fill="#D1D3D4" transform="translate(13.686 11.231)">
                    <g>
                      <path d="M14.1 15.9h23.7c.4 0 .7.4.7.8v.1c0 .5-.3.8-.7.8H14.1c-.4 0-.7-.4-.7-.8v-.1c0-.5.3-.8.7-.8z" />
                      <path d="M44.7 12.7L36.2 12.7 33.1 16.7 36.2 20.8 44.7 20.8 41.7 16.7z" />
                    </g>
                    <path d="M41.7 16.7L33.1 16.7 36.2 20.8 44.7 20.8z" />
                  </g>
                  <g transform="translate(13.38)">
                    <g>
                      <path
                        fill="#473080"
                        d="M13.4 27.5l16.8-16.8c.3-.3.8-.2 1.1.1l.1.1c.3.3.4.8.1 1.1L14.7 28.7c-.3.3-.8.2-1.1-.1l-.1-.1c-.3-.3-.4-.8-.1-1z"
                      />
                      <path
                        fill="#1CAEE4"
                        d="M32.9 3.6L26.8 9.6 27.5 14.7 32.5 15.3 38.5 9.3 33.5 8.6z"
                      />
                    </g>
                    <path
                      fill="#177BC0"
                      d="M33.5 8.6L27.5 14.7 32.5 15.3 38.5 9.3z"
                    />
                  </g>
                  <path
                    fill="#382B73"
                    d="M40.9 14.7l-14 13.9c.4.4.8.5 1.2.2l13.9-14-1.1-.1z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

ChallengeIcon.propTypes = {
  id: PropTypes.string,
};

ChallengeIcon.defaultProps = {
  id: '',
};

export default React.memo(ChallengeIcon);
